import styled from "@emotion/styled"
import {
	spacingStaticSm,
	spacingStaticMd,
	spacingStaticLg,
	spacingStaticXs,
} from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "../skeleton/Skeleton"
import { PageTeaserTags } from "./PageTeaserTags"

export const PageTeaserSkeleton = () => (
	<Wrapper>
		<ImageItem>
			<Skeleton.Picture />
		</ImageItem>
		<Content>
			<HeadingWrapper>
				<Skeleton.Heading size="sm" $width="50%" />
				<Skeleton.Heading size="xl" $width="70%" />
			</HeadingWrapper>
			<PageTeaserTags view={{ type: "skeleton" }} />
		</Content>
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${spacingStaticMd};
	padding: ${spacingStaticLg} 0;
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`

const HeadingWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
`

const ImageItem = styled.div`
	width: 160px;
`
